export default "__VITE_ASSET__8a2b963d__"